<div style="margin-bottom: 15px;"></div>
@if (!this.canManageAccess) {
<p class="as-error-text">You are not authorized to manage access.</p>
<p>Any of the following permissions are required:</p>
<ul>
  <li>Administrator Passwords</li>
  <li>Role Management</li>
  <li>Manage Groups</li>
</ul>
} @else {
<div class="button-row">
  @if(useInlineTitle) {
  <mat-toolbar>
    <mat-icon>lock</mat-icon>
    <span>{{ 'Admins.Management.Authorization.Access' | translate:locale.language }}</span>
  </mat-toolbar>
  }
  <div class="actions" [class.with-padding]="useInlineTitle">
    <ng-container *ngTemplateOutlet="authZAddButton; context: {collection: authorizedPeople }"></ng-container>
    <ng-container *ngTemplateOutlet="authZAddButton; context: {collection: authorizedRoles }"></ng-container>
    <ng-container *ngTemplateOutlet="authZAddButton; context: {collection: authorizedOwner }"></ng-container>
  </div>
</div>
<div class="access-table">
  <ng-container *ngTemplateOutlet="authZCollectionTable; context: { collection: authorizedOwner }"></ng-container>
  <ng-container *ngTemplateOutlet="authZCollectionTable; context: { collection: everyoneAuthorization }"></ng-container>
  <ng-container *ngTemplateOutlet="authZCollectionTable; context: { collection: authorizedPeople }"></ng-container>
  <ng-container *ngTemplateOutlet="authZCollectionTable; context: { collection: authorizedRoles }"></ng-container>
</div>

<ng-container *ngIf="hasCustomAuthorization">
  <mat-divider></mat-divider>
  <app-abac-authorization [metadata]="metadata"></app-abac-authorization>
</ng-container>
}


<ng-template #authZCollectionTable let-collection="collection">
  <section *ngIf="collection && collection.can && collection.hasValues">
    <table mat-table [dataSource]="collection.datasource" class="authorization-table">
      <!-- name column -->
      <ng-container matColumnDef="_authz_col_name">
        <th class="authz-header-cell" mat-header-cell *matHeaderCellDef>{{collection.type}}</th>
        <td mat-cell *matCellDef="let item; let i = index">
          <div class="icon-text">
            <mat-icon>{{collection.icon}}</mat-icon>
            <span [attr.data-test]="getDataTestAttr(collection.type, 'name', i)">{{item.name}}</span>
          </div>
        </td>
      </ng-container>
      @for(action of collection.actions; track action;)
      {
      <!-- action column -->
      <ng-container [matColumnDef]="action">
        <th class="authz-header-cell action-cell" mat-header-cell *matHeaderCellDef>{{
          'Admins.Management.Authorization.Actions.' + action | translate:locale.language
          }}</th>
        <td class="action-cell" mat-cell *matCellDef="let item; let i = index">
          <mat-checkbox [attr.data-test]="getDataTestAttr(collection.type, action, 'checkbox', i)"
            [aria-label]="getActionTip(collection.type, action)"
            [disabled]="collection.isActionReadonly(item, action, metadata) || isReadOnlyMode"
            [checked]="item.hasAction(action)"
            (change)="onToggleModelAction(action, item, collection, $event)"></mat-checkbox>
        </td>
      </ng-container>
      }
      <!-- delete column -->
      <ng-container matColumnDef="_authz_col_removeItem">
        <th class="action-cell" mat-header-cell *matHeaderCellDef></th>
        <td class="action-cell" mat-cell *matCellDef="let item; let i = index">
          @if(collection.canDeleteItems && !isReadOnlyMode) {
          <button type="button" [attr.data-test]="getDataTestAttr(collection.type, 'delete', i)" mat-icon-button
            [attr.aria-label]="getRemoveButtonTip(collection.type, item.name)"
            (click)="onDeleteModel(item, collection)">
            <mat-icon>delete</mat-icon>
          </button>
          } @else {
          <!-- for column alignment when the delete button is not shown -->
          <div style="width: 40px;"></div>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="collection.columns"></tr>
      <tr [attr.data-test]="collection.type + '_row_' + i" mat-row
        *matRowDef="let row; columns: collection.columns; let i = index"></tr>
    </table>
  </section>
</ng-template>

<ng-template #authZAddButton let-collection="collection">
  <button type="button" [attr.aria-label]="getAddButtonTip(collection.type)"
    *ngIf="collection?.addButton?.show && !isReadOnlyMode"
    [attr.data-test]="getDataTestAttr(collection.type, 'add_button')" mat-flat-button color="primary"
    (click)="onAdd(collection)">
    <mat-icon>{{collection.addButton.icon}}</mat-icon>
    <span>
      {{ collection.addButton.localizationKey | translate:locale.language }}
    </span>
  </button>
</ng-template>